@if (isDoorVersion2) {
  <div class="handles-choice mat-elevation-z3">
    <label>{{ 'WINDOW|Klamki, pochwyty'|translate | uppercase }}</label>
    <mat-radio-group [ngModel]="handleType$ | async" (ngModelChange)="setHandleType($event)">
      <mat-radio-button value="DoubleLever">{{'DOOR|Klamka dwustronna' | translate}}  </mat-radio-button>
      @if (!noLeverPull) {
        <mat-radio-button value="LeverPull">{{'DOOR|Klamka wewnętrzna/antaba na zewnątrz' | translate}}</mat-radio-button>
      }
      @if (!noDoublePull) {
        <mat-radio-button value="DoublePull">{{'DOOR|Antaba obustronna' | translate}}</mat-radio-button>
      }
    </mat-radio-group>
  </div>
}
@if ((selectHandlerType$ | async) && (hasOuterHandles('DoubleLever') || hasOuterHandles('LeverPull'))) {
  <div class="handles-choice mat-elevation-z3">
    <label>{{ 'WINDOW|Klamki, uchwyty'|translate | uppercase }}</label>
    <mat-radio-group [ngModel]="handleType$ | async" (ngModelChange)="setHandleType($event)">
      @if (hasOuterHandles('DoubleLever')) {
        <mat-radio-button value="DoubleLever">{{'WINDOW|Klamka obustronna' | translate}}  </mat-radio-button>
      }
      @if (hasOuterHandles('LeverPull')) {
        <mat-radio-button value="LeverPull">{{'WINDOW|Klamka-uchwyt' | translate}}</mat-radio-button>
      }
      <mat-radio-button value="InnerLever">{{'WINDOW|Klamka wewnętrzna' | translate}}</mat-radio-button>
    </mat-radio-group>
  </div>
}

@if (onlyInWindow) {
  <icc-select-box
    [title]="'WINDOW|Okucie' | translate"
    [description]="(selectedFitting$ | async)!.name"
    [imageUrl]="'/files/windowfitting/' + (selectedFitting$ | async).img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isFittingSelectionDisabled()"
    (select)="selectFitting()"
  ></icc-select-box>
}

@if (onlyInWindow && innerLeverBoxSelect.hasHandle) {
  <icc-select-box
    [title]="'WINDOW|Klamka' | translate"
    [description]="innerLeverBoxSelect?.name + ' (' + innerLeverBoxSelect?.color  + ')'"
    [imageUrl]="innerLeverBoxSelect?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled('window', 'innerLever', 'innerLever')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHandle(innerLeverBoxSelect.selectType, 'innerLever')"
    (select2)="changeHandleOptions(innerLeverBoxSelect.selectType, 'innerLever')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="innerLeverBoxSelect"
  ></icc-select-box>
}

@if ((showOuterHandles$ | async) && (selectHandlerType$ | async)) {
  <icc-select-box
    [title]="'DOOR|Klamka zewnętrzna' | translate"
    [description]="outerLeverBoxSelect!.name"
    [imageUrl]="outerLeverBoxSelect!.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled(outerLeverBoxSelect.selectType, 'outerLever')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select) = "selectHandleDoor(outerLeverBoxSelect.selectType, 'outerLever')"
    (select2)="changeHandleOptions(outerLeverBoxSelect.selectType, 'outerLever')"
    [descriptionTemplate]="outerHandleBoxTemplate"
    [descriptionContext]="outerLeverBoxSelect"
  ></icc-select-box>
}

@if ((showOuterPullBox$ | async) && isOuterHandleWindow) {
  <icc-select-box
    [title]="'WINDOW|Uchwyt' | translate"
    [description]="outerPullBoxSelect.name"
    [imageUrl]="outerPullBoxSelect.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled('default', 'outerPull')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHandleDoor('default', 'outerPull')"
    (select2)="changeHandleOptions('default', 'outerPull')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="outerPullBoxSelect"
  ></icc-select-box>
}

@if ((showDoubleLeverBox$ | async) && (isDoorVersion2)) {
  <icc-select-box
    [title]="'DOOR|Klamka dwustronna' | translate"
    [description]="innerLeverBoxSelect!.name"
    [imageUrl]="innerLeverBoxSelect!.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled(innerLeverBoxSelect.selectType, 'innerLever')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select) = "selectHandleDoor(innerLeverBoxSelect.selectType, 'innerLever')"
    (select2)="changeHandleOptions(innerLeverBoxSelect.selectType, 'innerLever')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="innerLeverBoxSelect"
  ></icc-select-box>
}

@if ((showInnerLeverBox$ | async) && (isDoorVersion2)) {
  <icc-select-box
    [title]="'DOOR|Klamka wewnętrzna' | translate"
    [description]="innerLeverBoxSelect!.name"
    [imageUrl]="innerLeverBoxSelect.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled(innerLeverBoxSelect.selectType, 'innerLever')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHandleDoor(innerLeverBoxSelect.selectType, 'innerLever')"
    (select2)="changeHandleOptions(innerLeverBoxSelect.selectType, 'innerLever')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="innerLeverBoxSelect"
  ></icc-select-box>
}

@if ((showInnerPullBox$ | async) && (isDoorVersion2)) {
  <icc-select-box
    [title]="'DOOR|Antaba wewnątrz' | translate"
    [description]="innerPullBoxSelect!.name"
    [imageUrl]="innerPullBoxSelect!.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled(innerPullBoxSelect.selectType, 'innerPull')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHandleDoor(innerPullBoxSelect.selectType, 'innerPull')"
    (select2)="changeHandleOptions(innerPullBoxSelect.selectType, 'innerPull')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="innerPullBoxSelect"
  ></icc-select-box>
}

@if ((showOuterPullBox$ | async) && !isOuterHandleWindow) {
  <icc-select-box
    [title]="'DOOR|Antaba na zewnątrz' | translate"
    [description]="outerPullBoxSelect.name"
    [imageUrl]="outerPullBoxSelect.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHandleSelectionDisabled(outerPullBoxSelect.selectType, 'outerPull')"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHandleDoor(outerPullBoxSelect.selectType, 'outerPull')"
    (select2)="changeHandleOptions(outerPullBoxSelect.selectType, 'outerPull')"
    [descriptionTemplate]="handleBoxTemplate"
    [descriptionContext]="outerPullBoxSelect"
  ></icc-select-box>
}

@if (showHingeSelectBox) {
  <icc-select-box
    [title]="'DOOR|Zawias' | translate"
    [description]="(selectedHinge$ | async)!.name"
    [imageUrl]="getHingeImageUrl()"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHingeSelectionDisabled()"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectHinge()"
    (select2)="changeHingeOptions()"
    [descriptionTemplate]="hingeBoxTemplate"
    [descriptionContext]="hingeBoxSelect"
  ></icc-select-box>
}


<ng-template #handleBoxTemplate let-name="name" let-color="color" let-colorOuter="colorOuter" let-description="description" let-hasSecondColor="hasSecondColor">
  <p> <b>{{ 'WINDOW|Model:' | translate }}</b> {{name}}</p>
  @if (!hasSecondColor && color) {
    <p>
      <b>{{ 'WINDOW|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  @if (hasSecondColor) {
    <p>
      <b>{{ 'WINDOW|Kolor wewnętrzny:' | translate }}</b> {{color}}<br>
      <b>{{ 'WINDOW|Kolor zewnętrzny:' | translate }}</b> {{colorOuter}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #outerHandleBoxTemplate let-name="name" let-color="colorOuter" let-description="description">
  <p> <b>{{ 'WINDOW|Model:' | translate }}</b> {{name}}</p>
  <p>
    <b>{{ 'WINDOW|Kolor:' | translate }}</b> {{color}}
  </p>
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #hingeBoxTemplate let-name="name" let-color="color" let-description="description" let-hasSecondColor="hasSecondColor">
  <p> <b>{{ 'WINDOW|Model:' | translate }}</b> {{name}}</p>
  @if (!hasSecondColor) {
    <p>
      <b>{{ 'WINDOW|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  @if (hasSecondColor) {
    <p>
      <b>{{ 'WINDOW|Kolor wewnętrzny:' | translate }}</b> {{color}}<br>
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>
